define([
	"dojo/_base/declare",
	"csi/constants",
	"csi/gallery/Widget",
	"csi/state"
], function(declare, constants, Widget, state) {

	return declare(Widget, {
		// Boolean: displays full size original image if required
		bAllowOriginal: true,

		_buildView: function() {
			//summary: add options to display full size images on ImageDataSheet if custom view settings demand bigger images
			if (state.get("print")) {
				// galleryImageHeight and galleryImageWidth gets reset on viewStart before buildView is called so apply on buildView instead of onViewPreferences
				var IMAGEPADDING = 15;
				var maxWidth = state.get("printWidth") - IMAGEPADDING;

				if (this.galleryImageWidth > maxWidth) {
					// re adjust width so on print view images don't overflow
					this.set("galleryImageWidth", maxWidth);

					// set gallery attribute width to gallery image width if gallery template is not attribute right
					if (this.galleryTemplate !== constants.GALLERY_TEMPLATE_RIGHT) {
						this.set("galleryAttributeWidth", maxWidth);
					}
				}

				if (this.galleryImageHeight > state.get("printHeight")) {
					this.set("galleryRowsPerPage", 1);
				}
			}

			this.inherited(arguments);
		}
	});
});